export class Endpoints {
  public static baseUrl = process.env.VUE_APP_API_URL

  // tslint:disable-next-line: max-classes-per-file
  public static Route = class {
    public static ADMIN_DASHBOARD = '/admin/report/dashboard'
    public static ADMIN_CMS = '/admin/admins'
    public static ADMIN_ROLE_LIST = '/admin/master/role'
    public static ADMIN_CMS_ROLE = '/admin/admins/role'
    public static ADMIN_CMS_ROLE_ADD = '/admin/admins/createrole'
    public static ADMIN_CMS_ROLE_DELETE = '/admin/admins/deleterole'
    public static ADMIN_CMS_ROLE_UPDATE = '/admin/admins/role'
    public static USERS_CMS_DELETE = '/admin/admins/delete'
    public static ADMIN_LIST = '/admin/list'
    public static ADMIN_LOGIN = '/admin/auth/login'
    public static ADMIN_ME = '/admin/me'
    public static ADMIN_REGISTER = '/admin/register'
    public static ADMIN_ROLE = '/role'
    public static HOME_BANNER = '/admin/banners'
    public static HOME_BANNER_DELETE = '/admin/banners/delete'
    public static FAQ = '/admin/faqs'
    public static FAQ_DELETE = '/admin/faqs/delete'
    public static MASTER_CAR = '/admin/master-cars'
    public static MATERIAL_BULLETIN = '/admin/bulletins'
    public static MATERIAL_BULLETIN_DELETE = '/admin/bulletins/delete'
    public static MATERIAL_ADDITIONAL = '/admin/infos'
    public static MATERIAL_ADDITIONAL_DELETE = '/admin/infos/delete'
    public static NOTIFICATION_DELETE = '/admin/notifications/delete'
    public static NOTIFICATION = '/admin/notifications'
    public static PRIVACY_POLICY = '/static/privacy'
    public static REPORT = '/report'
    public static REPORT_TRAINING_MATERIAL = 'admin/report/training'
    public static REPORT_ADDITIONAL_INFO = 'admin/report/info'
    public static REPORT_NOTIFICATION = '/admin/report/notification'
    public static REPORT_PKT = '/report/pkt'
    public static REPORT_QUICKGUIDE = 'admin/report/sop'
    public static REPORT_BULLETIN = 'admin/report/bulletin'
    public static REPORT_USER = 'admin/report/user'
    public static TERM_CONDITION = '/static/term'
    public static TRAINING_CATEGORY = '/admin/master-cars'
    public static TRAINING_CATEGORY_DELETE = '/admin/master-cars/delete'
    public static TRAINING_MATERIAL = '/admin/training-materials'
    public static TRAINING_MATERIAL_DELETE = '/admin/training-materials/delete'
    public static GUIDE_CATEGORY = '/admin/master-cars'
    public static GUIDE_CATEGORY_DELETE = '/admin/gmaster-cars/delete'
    public static GUIDE_MATERIAL = '/admin/sop-materials'
    public static GUIDE_MATERIAL_DELETE = '/admin/sop-materials/delete'
    public static USERS = '/admin/users'
    public static USERSDNET = '/admin/users/updateDnet'
    public static USERS_DELETE = '/admin/users/delete'
    public static RECOMENDATION = '/admin/recommendations'
    public static RECOMENDATION_DELETE = '/admin/recommendations/delete'
    public static GALLERY = '/admin/galleries'
    public static GALLERY_DELETE = '/admin/galleries/delete'
    public static OTHER_CONTENT = '/admin/contents'
    public static POSITION = '/admin/master/sfd-positions'
    public static POSITION_DNET = '/admin/master/job-positions'
    public static POSITION_DELETE = '/admin/master/sfd-positions/delete'
    public static MASTER = '/admin/master'
    public static EXPORT = '/admin/users/export'
    public static EXPORT_BULLETIN = '/admin/report/export-bulletin'
    public static EXPORT_INFO = '/admin/report/export-info'
    public static EXPORT_TRAINING = '/admin/report/export-training'
    public static EXPORT_GUIDE = '/admin/report/export-sop'
    public static IMPORT = '/admin/users/import'
  }
}
